import { render, staticRenderFns } from "./RipeavMore.vue?vue&type=template&id=7157c38a&scoped=true&"
import script from "./RipeavMore.vue?vue&type=script&lang=js&"
export * from "./RipeavMore.vue?vue&type=script&lang=js&"
import style0 from "./RipeavMore.vue?vue&type=style&index=0&id=7157c38a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7157c38a",
  null
  
)

export default component.exports